// Local translations
export const T = {
  en_GB: {
    noWrapperTypesWarning:
      'This portfolio collection needs at least one active wrapper type because "Enable Wrapper Types" is turned on. Add a wrapper type below, or disable the setting.',
  },
  nb_NO: {
    noWrapperTypesWarning:
      'Denne porteføljesamlingen trenger minst én aktiv innpakningstype fordi "Aktiver innpakningstyper" er slått på. Legg til en innpakningstype nedenfor, eller slå av innstillingen.',
  },
} as const;
